import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getBuyerForecastTableData = createApi(`BuyerForecastTableDataSlice`,"GET");

const BuyerForecastTableDataSlice = createSlice({
  name: 'BuyerForecastTableDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBuyerForecastTableData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBuyerForecastTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBuyerForecastTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default BuyerForecastTableDataSlice.reducer;